import { WebAppointmentForChargeFragment } from '~/graphql/generated/graphql';
import { useB2cloud } from '~/hooks/use-b2cloud';

/**
 * 配送方法も増えていくかもしれないのでデフォルト配送方法をこのHookいまとめる
 */

export const useDefaultDelivery = (appointment: WebAppointmentForChargeFragment | null) => {
  const { defaultInvoiceType: b2cloudDefault, enabledB2cloud } = useB2cloud();

  if (!appointment?.telemedicine) {
    return 'hand';
  }

  if (enabledB2cloud) {
    switch (b2cloudDefault) {
      case 'cash_on_delivery':
        return 'b2cloud_cash_on_delivery';
      case 'collect':
        return 'b2cloud_collect';
      case 'compact':
        return 'b2cloud_compact';
      case 'compact_collect':
        return 'b2cloud_compact_collect';
      case 'dm':
        return 'b2cloud_dm';
      case 'nekopos':
        return 'b2cloud_nekopos';
      case 'prepayment':
        return 'b2cloud_prepayment';
      case 'time':
        return 'b2cloud_time';
      default:
        break;
    }
  }

  return 'parcel';
};
